<template>
  <div :class="[chapterClass, 'content']" @click="changeSetting">
    <div
      style="background-color: #1e1e1e"
      class="arrow-img"
      v-if="
        showSetting &&
        (routePages == 1 || pageType == 'index' || pageType == 'bookFrency')
      "
    ></div>
    <div v-if="readingStyle == 1" class="content-box">
      <span
        v-if="chapterInfo.chapterOrders"
        class="chapter-title"
        :style="{
          fontSize: (fontSizeChange * 1.5 - 2) / 16 + 'rem',
          lineHeight: (fontSizeChange * lineHeight) / 16 + 'rem',
          marginBottom: (fontSizeChange - 10) / 16 + 'rem',
        }"
      >
        第{{ chapterInfo.chapterOrders ? chapterInfo.chapterOrders : 1 }}章
        {{ chapterInfo.chapterName }}</span
      >
      <span
        class="chapter-content"
        :style="{
          fontSize: fontSizeChange / 16 + 'rem',
          lineHeight: (fontSizeChange * lineHeight) / 16 + 'rem',
          marginBottom: (fontSizeChange - 10) / 16 + 'rem',
        }"
        v-for="(item, index) in chapterContent"
        :key="index"
        >{{ item }}</span
      >
    </div>

    <div class="cata-btn" v-if="readingStyle == 1 && chapterContent.length > 0">
       <span @click.stop="jumpChapter(2)">下一章</span>          
      <div class="cata-btn-bottom">
        <span @click.stop="jumpChapter(1)">上一章</span
        ><span @click.stop="showCata">目录</span>
      </div>
    </div>
    <div v-if="readingStyle == 0">
      <div :class="[borderClass, 'content_title']">
        <div>
          <img
            @click.stop="showCata"
            :src="
              backgroundColor == 'night'
                ? '../../../static/night_cata.png'
                : '../../../static/day_cata.png'
            "
            alt=""
          />
          <span v-if="chapterInfo.chapterOrders">
            第{{ chapterInfo.chapterOrders ? chapterInfo.chapterOrders : 1 }}章
            {{ chapterInfo.chapterName }}</span
          >
        </div>
        <span @click.stop="routeTabbar(4)" :class="backgroundColor + '-content'"
          >投诉</span
        >
      </div>
      <div class="read_set">
        <div style="display: flex">
          <span
            @click.stop="changeSize('reduce')"
            :class="backgroundColor + '_reduce'"
            >A-</span
          >
          <span
            @click.stop="changeSize('release')"
            :class="backgroundColor + '_reduce'"
            >A+</span
          >
          <div style="position: relative">
            <span
              style="width: 2.5rem"
              @click.stop="isShowColor = !isShowColor,isShowLine = false"
              :class="backgroundColor + '_reduce'"
              >背景</span
            >
            <div v-if="isShowColor" class="setting-topcolor">
              <div
                v-for="(item, index) in backgroundColorName"
                class="bg-color"
                @click.stop="changeColor(item)"
                :key="index"
              >
                <span
                  v-if="item.bgColor"
                  :class="backgroundColor == item.color ? 'active' : ''"
                  :style="{ background: item.bgColor }"
                ></span>
                <span
                  v-else
                  :class="backgroundColor == item.color ? 'active' : ''"
                  style="background-image: url(../../../static/yang-choose.png)"
                ></span>
              </div>
            </div>
          </div>
          <div style="position: relative">
            
          <img
          v-if="backgroundColor == 'night'"
            @click.stop="isShowLine = !isShowLine,isShowColor = false"
              :class="backgroundColor + '_reduce'"
            src="../../../static/whiteLine.png"
            alt=""
          />
          <img
            v-else
            @click.stop="isShowLine = !isShowLine,isShowColor = false"
              :class="backgroundColor + '_reduce'"
            src="../../../static/lineIcon.png"
            alt=""
          />
            <div v-if="isShowLine" class="setting-linehegiht">
              <div
                v-for="(item, index) in linHeightList"
                class="bg-color"
                @click.stop="changeLineHeight(item)"
                :key="index"
              >
              <img   :src="lineHeight == item.value ?( '../../../static/'+item.value+'selected.png'):( '../../../static/'+item.value+'unselect.png')">
              </div>
            </div>
          </div>
          <img
            @click.stop="changeMoon"
            v-show="backgroundColor == 'night'"
            src="../../../static/sun_2.png"
            alt=""
          />
          <img
            @click.stop="changeMoon"
            v-show="backgroundColor != 'night'"
            src="../../../static/moon_2.png"
            alt=""
          />
        </div>
        <div>
          <img
            @click.stop="routabbarIndex(1)"
            style="width: 3.5625rem; height: 1.5rem; margin-right: 0px"
            :src="'../../../static/' + backgroundColor + '_index.png'"
            alt=""
          />
        </div>
      </div>
      <div style="padding: 0px 1rem">
        <span
          class="chapter-content"
          :style="{
            fontSize: fontSizeChange / 16 + 'rem',
            lineHeight: (fontSizeChange * lineHeight) / 16 + 'rem',
            marginBottom: (fontSizeChange - 10) / 16 + 'rem',
          }"
          v-for="(item, index) in chapterContent"
          :key="index"
          >{{ item }}</span
        >
        <div class="collect" v-if="collectBook == 1" @click="showCollect">
          点击此处，收藏本书>
        </div>
        <div
          style="padding-bottom: 1.25rem"
          :class="[backgroundColor + '-cata-btn', 'common-cata-btn']"
          v-if="chapterContent.length > 0"
        >
          <span  @click.stop="jumpChapter(2)">下一章</span>
          <div class="cata-btn-bottom">
            <span @click.stop="jumpChapter(1)">上一章</span>
            <span @click.stop="showCata">目录</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部二维码 -->
    <div class="qCode_bottom" v-if="bottomOfPageQrCodeUrl">
      <p :class="backgroundColor == 'night' ? 'qCode_Text' : ''">
        关注公众号，阅读更多精彩好书
      </p>
      <img
        :style="{
          'background-color': backgroundColor == 'night' ? '#ffffff' : '',
        }"
        :src="bottomOfPageQrCodeUrl"
        alt=""
      />
      <p>长按二维码即可识别关注</p>
    </div>
    <!-- 收藏弹窗 -->
    <div
      class="collect-mask"
      v-if="isShowCollect"
      @click="isShowCollect = false"
    >
      <img src="../../../static/1.png" alt="" />
      <img src="../../../static/2.png" alt="" />
      <img src="../../../static/3.png" alt="" />
      <!-- <img @click="isShowCollect=false" src="../../../static/collect-mask.png" alt=""> -->
    </div>
    <div class="read-top" v-if="showSetting">
      <img @click="goback" src="../../../static/white_back_ic.png" alt="" />
      <div>
        <div
          v-for="(item, index) in tabbar"
          :key="index"
          @click.stop="routeTabbar(index)"
        >
          <img :src="item.iconPath" mode="" /><span>{{ item.text }}</span>
        </div>
      </div>
    </div>
    <div class="setting" v-show="showSetting">
      <div class="setting-bottom">
        <div @click.stop="jumpChapter(1)">
          <img src="../../../static/last_chapter.png" alt="" /><span
            >上一章</span
          >
        </div>
        <span
          >第{{ chapterInfo.chapterOrders ? chapterInfo.chapterOrders : 1 }}章
          {{ chapterInfo.chapterName }}</span
        >
        <div @click.stop="jumpChapter(2)">
          <img src="../../../static/next_chapter.png" alt="" /><span
            >下一章</span
          >
        </div>
      </div>
      <div class="setting-color">
        <span>主题</span>
        <div
          v-for="(item, index) in backgroundColorName"
          @click.stop="changeColor(item)"
          :key="index"
        >
          <span
            v-if="item.bgColor"
            :class="backgroundColor == item.color ? 'active' : ''"
            :style="{ background: item.bgColor }"
          ></span>
          <span
            v-else
            :class="backgroundColor == item.color ? 'active' : ''"
            style="background-image: url(../../../static/yang-choose.png)"
          ></span>
        </div>
      </div>
      <div class="setting-btn">
        <div @click.stop="showCata">
          <img src="../../../static/list.png" alt="" />
          <span>章节目录</span>
        </div>
        <div @click.stop="changeSize('release')">
          <img src="../../../static/release.png" alt="" />
          <span>字体增大</span>
        </div>
        <div @click.stop="changeSize('reduce')">
          <img src="../../../static/reduce.png" alt="" />
          <span>字体缩小</span>
        </div>
        <div @click.stop="changeMoon">
          <img
            style="width: 16px; height: 16px"
            :src="
              backgroundColor == 'night'
                ? '../../static/sun.png'
                : '../../static/moon.png'
            "
            mode=""
          />
          <span>{{
            backgroundColor == "night" ? "日间模式" : "夜间模式"
          }}</span>
        </div>
      </div>
    </div>
    <!-- 目录弹窗 -->
    <uniCatacom
      v-if="openCata"
      :toview="toView"
      :bookinfo="bookInfo"
      :bookid="bookid"
      :chapterorder="chapterInfo.chapterOrders"
      @emitEvt="emitEvt"
    ></uniCatacom>
    <!-- 推荐书籍 -->
    <div class="recommand-mask" v-if="isOutReader">
      <div>
        <span>{{ randerNum }}%的人都在看的好书</span>
        <div class="recommand-content">
          <div
            v-for="(itemChild, index) in recommendList"
            :key="index"
            @click.stop="routeRead(itemChild)"
          >
            <uniListItem :itemChild="itemChild"></uniListItem>
          </div>
        </div>
        <div class="recommand-btn">
          <span @click.stop="routeBack">退出阅读</span>
          <span @click.stop="isOutReader = false">继续阅读</span>
        </div>
      </div>
    </div>
    <!-- 活动角标 -->
    <div class="activity-mask" v-if="ShowActivity">
      <img
        class="icon-img"
        :src="readerUrl"
        @click.stop="routeActivity"
        alt=""
      />
      <img
        @click.stop="ShowActivity = false"
        class="delete-activity"
        src="../../../static/activity_close.png"
        alt=""
      />
    </div>
    <!-- 二维码遮罩 -->
    <qCode
      :qcodeUrl="qcodeUrl"
      :isShowQcode="isShowQcode"
      @eventChange="eventChange"
    ></qCode>
    <!-- 整本购买遮罩 -->
    <buyBook
      :showBuyMask="showBuyMask"
      :countCurrency="countCurrency"
      @buyChange="buyChange"
      :userCurrency="userCurrency"
    ></buyBook>
    <autoBuy :isOpen='isOpen' :showAutoBuyMask="showAutoBuyMask"
      :countCurrency="countCurrency"
      @autobuyChange="autobuyChange"
      :userCurrency="userCurrency"></autoBuy>
      <popActivity  :tabbarIndex="5" ref='popChild'></popActivity>
  </div>
</template>
<script>
import { Toast, MessageBox } from "mint-ui";
var bookOffset = [];
import wx from "weixin-js-sdk";
import uniCatacom from "./component/cata_component.vue";
import uniListItem from "../components/list-item.vue";
import qCode from "./component/qcode.vue";
import arrorImg from "../../components/arrow-img.vue";
import buyBook from "../components/buyBook.vue";
import autoBuy from "../components/autoBuy.vue";
import popActivity from "../components/pop-activity.vue";
export default {
  name: "bookRead",
  components: {
    uniCatacom,
    uniListItem,
    qCode,
    arrorImg,
    buyBook,
    autoBuy,
    popActivity
  },
  data() {
    return {
      chapterNewId:0,
      collectBook: 0, //收藏书籍
      isShowCollect: false,
      bottomOfPageQrCodeUrl: "", //二维码
      countCurrency: 0, //整本书币，
      showBuyMask: false, //显示整本订购弹窗
      showAutoBuyMask:false,//显示是否订阅弹窗
      userCurrency: 0, //用户剩余书币
      isShowColor: false,
      isShowLine:false,
      isEntranceData: "",
      isShowQcode: false,
      qcodeUrl: "",
      bookInfo: {},
      bookid: 0,
      chapterid: -1,
      pageType: "",
      chapterParams: {
        bookId: "",
        chapterId: -1, //章节排序order
        chapterorder: 0,
        order: 0, //翻页标示 0:获取当前章节内容 1: 前一章 2：后一章,4从目录进入阅读器,3购买章节
        booktype: "",
        isauto: 0,//自动订阅1 0不自动订阅
        rechargeOrderNum: "", //订单编号
        purchaseWholeBook: 0, //是否整本订购
        currentPageType: 0,
      },
      fontSizeChange: 20,
      chapterContent: [], //章节内容
      chapterInfo: {},
      chapterClass: "gray-content",
      borderClass: "gray-border",
      cataInfo: {},
      backgroundColorName: [
        {
          name: "灰色背景",
          color: "gray",
          bgColor: "#ECEDEC",
        },
        {
          name: "护眼",
          color: "green",
          bgColor: "#D3E2CD",
        },
        {
          name: "黄色背景",
          color: "yellow",
          bgColor: "#F1E4C8",
        },
        {
          name: "蓝色背景",
          color: "blue",
          bgColor: "#E3E7EB",
        },
      ],
      linHeightList: [
        {
          value: 1.6
        },
        {
          value: 1.8
        },
        {
          value: 2
        },
        {
          value: 2.2
        },
      ],
      backgroundColor: "gray",
      prevBgcolor: "gray",
      showSetting: false,
      openCata: false,
      startTime: "",
      endTime: "",
      duration: "",
      randerNum: 99,
      isOutReaderStatus: 0,
      recommendList: [],
      isOutReader: false,
      prevPage: "", //保存当前页面跳转的路由
      activityId: 0,
      readerUrl: "",
      ShowActivity: false,
      isChargereturn: false, //判断是否是充值页返回的
      tabbar: [
        {
          iconPath: "../../static/read_shujia.png",
          text: "书架",
        },
        {
          iconPath: "../../static/read_shucheng.png",
          text: "书城",
        },
        {
          iconPath: "../../static/read_fuli.png",
          text: "福利",
        },
        {
          iconPath: "../../static/read_wode.png",
          text: "我的",
        },
        {
          iconPath: "../../static/tousu.png",
          text: "",
        },
      ],
      routePages: 0,
      isDetail_Next: 0,
      readingOffset: 0,
      readingScrollIndex: 0,
      isSetInsert: 0, //第一次进入阅读器是否请求上报设置的接口
      isChangeRecord: false, //是否修改阅读器内的设置
      shareContent: "",
      readingStyle: 0, //0 新样式 1旧样式
      toView: 0,
      externalLink: "",
      continueRead: "",
      isRecommond: -1, //是否调用过这个接口
      isReturn: false,
      scrollTop: "",
      bookIdA:'',
      isOpen:0,
      lineHeight:1.8,
      fromPage:''
    };
  },
  mounted() {
    window.addEventListener("popstate", this.fun, false); //false阻止默认事件
 
  },
  beforeRouteLeave(to, from, next) {
    console.log("离开页面之前");
    this.endTime = this.$base.getCurrentDateTimeSeconds();
    this.duration = this.endTime - this.startTime;
    this.isOpen=0;
    this.sendReadTime(); //上报阅读时间
    if (!this.showSetting && this.isChangeRecord) {
      //上报修改阅读器设置
      this.insertReaderRecord();
    }
    window.removeEventListener("scroll", this.handleScroll, false);
    this.$base.setStorage("bookOffset", JSON.stringify(bookOffset));
    next();
    // 调用
  },
  beforeRouteEnter(to, from, next) {
    if (
      ((from.path == "/" && from.name != "tabbar") ||
        from.name == "bookCharge" ||
        from.name == "bookActivity"||from.name == "bookModelActivity"||from.name=='bookRecommandread'||from.name=='bookComplaint') &&
      to.name == "bookRead"
    ) {
      to.meta.isBack = true;
      to.meta.keepAlive = true;
    } else {
      to.meta.isBack = false;
      to.meta.keepAlive = true;
    }
     console.log(from);
    console.log(to);
   next(vm => {
        vm.fromPage=from.name;
        vm.isOpen=1;
      })

  },
  activated() {
    this.isRecommond = -1;
    this.isOpen=1;
    console.log("isBack" + this.$route.meta.isBack);
    console.log(this.fromPage);
    this.isShowColor = false;
    this.isShowLine = false;
    this.openCata = false;
    this.isReturn = false;
    this.pageType = this.$route.query.pageType;
    this.bookid = this.$route.query.bookid;
    this.isDetail_Next = this.$route.query.isDetail_Next;
    if (this.$route.query.item) {
      this.cataInfo = JSON.parse(this.$route.query.item);
    } else {
      this.cataInfo = {};
    }
    if (this.$route.query.chapterId) {
      this.chapterid = this.$route.query.chapterId;
    } else {
      this.chapterid = -1;
    }
    if (this.$route.query.isEntranceData) {
      this.isEntranceData = this.$route.query.isEntranceData;
    } else {
      this.isEntranceData = "";
    }
    if (this.$route.query.continueRead) {
      this.continueRead = this.$route.query.continueRead;
    } else {
      this.continueRead = 0;
    }
    if (this.$route.query.externalLink) {
      this.externalLink = this.$route.query.externalLink;
    } else {
      this.externalLink = 0;
    }
    this.chapterParams.isauto=0;
    this.routePages = this["$router"].options.routes.length;
    var isActivity = this.$base.getStorage("isActivity");
    if (this.pageType != "bookRead") {
      this.prevPage = this.pageType;
      this.$base.setStorage("prevPage", this.prevPage);
    }
    if (this.$route.meta.isBack) {
      if (isActivity == 1 && this.$base.getStorage("orderNum")) {
        //订单支付成功
        this.getOrderStatus();
        this.getPayedContent();
      } else {
        // 页面从各个地方返回读取阅读记录
        this.$base.removeStorage("isActivity");
        var openid = this.$base.getStorage("openid");
        var isWxAuthorized = this.$base.getStorage("isWxAuthorized");
        var city = this.$base.getStorage("city");
        if (!openid) {
        } else if (
          isWxAuthorized == 0 &&
          city == 1 &&
          openid &&
          !this.$store.state.user.isSNS
        ) {
          this.$base.setStorage("isSNS", true);
          this.$store.state.user.isSNS = true;
          this.$commonApi.snsapiUserinfo();
          this.getContent(true);
        } else {
          this.getContent(true);
        }
        console.log("textaaaaaa");
      }
    } else {
      this.$base.removeStorage("isActivity");
      var openid = this.$base.getStorage("openid");
      var isWxAuthorized = this.$base.getStorage("isWxAuthorized");
      var city = this.$base.getStorage("city");
      if (!openid) {
      } else if (
        isWxAuthorized == 0 &&
        city == 1 &&
        openid &&
        !this.$store.state.user.isSNS
      ) {
        this.$base.setStorage("isSNS", true);
        this.$store.state.user.isSNS = true;
        this.$commonApi.snsapiUserinfo();
        this.getContent();
       
      } else {
        this.getContent();
       
      }
      this.$refs.popChild.monthCards();
      console.log("textbbbbbb");
    }
   
    this.readingScrollIndex = 0;
    window.addEventListener("scroll", this.handleScroll, false);
  },
  watch: {
    $route: {
      // 监听路由的参数变化
      handler(to, from) {
        console.log("监听路由变化");
        console.log(to);
        // 数据变化更新数据
        if (
          to.name == "bookRead" &&
          from.name == "bookRead" &&
          to.query.bookid
        ) {
           this.pageType = to.query.pageType;
          this.bookid = this.$route.query.bookid;
          this.getContent();
        }
      },
    },
  },
  beforeDestroy() {},
  methods: {
    getContent(flag) {
      //各个入口进入阅读器的流程
      this.$api.getOutReaderSwitckIsOpen().then((res) => {
        if (res.status == 1) {
          this.isOutReaderStatus = res.data.isOutReader;
          this.readingStyle = res.data.readingStyle ? res.data.readingStyle : 0;
          this.collectBook = res.data.collectBook;
          if (this.pageType == "bookCatalog" && !flag) {
            this.chapterParams.bookId = this.bookid;
            this.chapterParams.chapterId = this.cataInfo.id;
            this.chapterParams.chapterorder = this.cataInfo.chapterOrders;
            this.chapterParams.order = 4;
            this.initSetting();
            this.getChapterContent();
            console.log("目录进入");
          } else if (
            this.pageType === "bookDetail" &&
            this.isDetail_Next == 1 &&
            !flag
          ) {
            //从阅读详情下一章进入
            this.chapterParams.chapterId = this.cataInfo.chapterId;
            this.chapterParams.chapterorder = this.cataInfo.chapterOrder;
            this.chapterParams.bookId = this.bookid;
            this.chapterParams.order = 2;
            this.initSetting();
            this.getChapterContent(false);
            console.log("书籍详情下一章进入");
          } else {
            this.chapterParams.bookId = this.bookid;
            this.getBookReadLog(flag);
            console.log("剩余入口");
          }
          this.randerNum = (98 + Math.random() * (99.9 - 98)).toFixed(1);
          this.startTime = this.$base.getCurrentDateTimeSeconds(); //开始阅读时间
          this.getActivityReaderUrl();
          this.insertPageAccessData();
          this.getBottomOfPageQrCodeUrl();
        }
      });
    },
    getBottomOfPageQrCodeUrl() {
      //获取底部二维码
      this.$api.getBottomOfPageQrCodeUrl().then((res) => {
        if (res.status == 1) {
          this.bottomOfPageQrCodeUrl = res.data.bottomOfPageQrCodeUrl;
        }
      });
    },
    showCollect() {
      //显示收藏遮罩
      this.isShowCollect = true;
    },
    getOrderStatus() {
      var params = {
        orderNo: this.$base.getStorage("orderNum"),
        currentPageType: 0,
      };
      this.$base.removeStorage("isActivity");
      this.$api.getOrderStatus(params).then((res) => {
        if (res.status == 1) {
          Toast({
            message: res.message,
          });
        }
      });
    },
    handleScroll(e) {
      //修改成整数
      let top =
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.pageYOffset;
      // console.log(top);
      // console.log(300 < top && top < 500);
      if (300 < top && top < 500) {
        return false;
      }
      var that = this;
      var bo = false;
      this.readingScrollIndex++;
      if (this.readingScrollIndex == 1) {
        return false;
      }
      that.readingOffset = parseInt(top);
      bookOffset.forEach((item) => {
        if (item.bookid == that.bookid) {
          bo = true;
          if (that.readingOffset >= 0) {
            item.readingOffset = that.readingOffset;
          }
        }
      });
      if (!bo) {
        bookOffset.push({
          bookid: that.bookid,
          readingOffset: that.readingOffset,
        });
      }
      this.$base.setStorage("bookOffset", JSON.stringify(bookOffset));
    },
    buyChange(data) {
      //整本购买
      if (data) {
        if (data == 1) {
          this.chapterParams.purchaseWholeBook = 1;
          this.getChapterContent();
        } else if (data == 2) {
          this.$router.push({
            path: "/pages/bookCharge/index",
            query: {
              bookId: this.bookid,
              needCurrency: this.countCurrency,
              pageType: "bookRead",
            },
          });
        }
      } else {
        this.showBuyMask = false;
      }
    },
    autobuyChange(item) {
      //是否订阅
      if (item) {
        if (item.data == 1) {
          this.chapterParams.isauto = item.isauto;
          this.chapterParams.purchaseWholeBook =1;
          this.getChapterContent();
        } else if (item.data == 2) {
          this.showAutoBuyMask = false;
           this.chapterParams.isauto = item.isauto;
            this.$base.setStorage(
              "isauto",
              this.chapterParams.isauto
            );
               
          this.$router.push({
            path: "/pages/bookCharge/index",
            query: {
              bookId: this.bookid,
              needCurrency: this.countCurrency,
               chapterId: this.chapterNewId,
              pageType: "bookRead",
            },
          });
        }
        // else if(item.data == 3){
        //    this.chapterParams.isauto = item.isauto;
        // }
      } else {
        this.showAutoBuyMask = false;
      }
    },
    insertPageAccessData() {
      var pageType = "";
      if (this.pageType === "bookSelf") {
        pageType = "书架";
      } else if (this.pageType === "bookLastRead") {
        pageType = "最近阅读";
      } else if (this.pageType === "bookDetail") {
        pageType = "书籍详情";
      } else if (this.pageType === "bookCatalog") {
        pageType = "书籍目录";
      } else if (this.pageType === "bookCity"|| this.pageType ==='promotionLink') {
        pageType = "书城";
      } else if (this.pageType === "bookRead") {
        pageType = "阅读器";
        this.isEntranceData='(6:'+this.bookIdA+':-1:'+this.bookid+':-1:-1)'
      } else if (this.pageType === "bookRecharge") {
        pageType = "充值中心";
      }
      console.log(this.pageType)
      var params = {
        pageName: "阅读器",
        pageRemark: "上级页面：" + pageType + ";书籍ID：" + this.bookid,
        isEntranceData: this.isEntranceData
      };
      this.$api.insertPageAccessData(params).then((res) => {});
    },
    eventChange() {
      this.isShowQcode = false;
    },
    routabbarIndex() {
      this.$router.replace({
        path: "/",
      });
    },
    routeTabbar(index) {
      this.showSetting = false;
      if (!this.showSetting && this.isChangeRecord) {
        //上报修改阅读器设置
        this.insertReaderRecord();
      }
      if (index != 4) {
        this.$base.setStorage("tabbarIndex", index);
        this.$router.replace({
          path: "/",
        });
      } else {
        this.$router.push({
          path: "/pages/bookComplaint/index",
          pageType: "bookRead",
        });
      }
    },
    initSetting() {
      this.backgroundColor = this.$base.getStorage("backgroundColor")
        ? this.$base.getStorage("backgroundColor")
        : "gray";
        this.lineHeight= this.$base.getStorage("lineHeight")
        ? this.$base.getStorage("lineHeight")
        : 1.8;
      this.prevBgcolor = this.$base.getStorage("prevBgcolor")
        ? this.$base.getStorage("prevBgcolor")
        : "gray";
      this.fontSizeChange = this.$base.getStorage("fontSizeChange")
        ? this.$base.getStorage("fontSizeChange")
        : 20;
      this.chapterClass = this.backgroundColor + "-content";
      this.borderClass = this.backgroundColor + "-border";
      this.isSetInsert = this.$base.getStorage("isSetInsert")
        ? this.$base.getStorage("isSetInsert")
        : 0;
      bookOffset = this.$base.getStorage("bookOffset")
        ? JSON.parse(this.$base.getStorage("bookOffset"))
        : [];
      bookOffset.forEach((item) => {
        if (item.bookid == this.bookid) {
          this.readingOffset = item.readingOffset;
        }
      });
    },
    insertReaderRecord() {
      //上报阅读器设置
      var params = {
        pageTurning: "上下翻页",
        readBackground: this.backgroundColor,
        tradeNum: this.fontSizeChange,
        rowSpacing:this.lineHeight
      };
      this.$api.insertReaderRecord(params).then((res) => {
        if (res.status == 1) {
          this.isChangeRecord = false;
          this.$base.setStorage("isSetInsert", 1);
        }
      });
    },
  
    getActivityReaderUrl() {
      //获取活动角标
      this.$api.getActivityReaderUrl().then((res) => {
        if (res.status == 1) {
          this.activityId = res.data.activityId;
          this.readerUrl = res.data.imgUrl;
          if (!this.readerUrl) {
            this.ShowActivity = false;
          } else {
            this.ShowActivity = true;
          }
        }
      });
    },
    routeActivity() {
      //活动角标点击跳转到活动充值
      this.$base.setStorage("chapterOrder", this.chapterParams.chapterorder);
      this.$base.setStorage("chapterId", this.chapterParams.chapterId);
      this.$base.setStorage("order", 0);
      this.$router.push({
        path: "/pages/bookModelActivity/index",
        query: {
          activityId: this.activityId,
          pageType: "bookRead",
          bookId: this.bookid,
        },
      });
    },
    getPayedContent() {
      //获取支付之后的流程
      this.$api.getOutReaderSwitckIsOpen().then((res) => {
        if (res.status == 1) {
          this.isOutReaderStatus = res.data.isOutReader;
          this.collectBook = res.data.collectBook;
          this.readingStyle = res.data.readingStyle ? res.data.readingStyle : 0;
          this.chapterParams.bookId = this.bookid;
          this.chapterParams.order = this.$base.getStorage("order")
            ? this.$base.getStorage("order")
            : 0;
            this.chapterParams.isauto=this.$base.getStorage("isauto")
            ? this.$base.getStorage("isauto")
            : 0;
          this.chapterParams.rechargeOrderNum = this.$base.getStorage(
            "orderNum"
          )
            ? this.$base.getStorage("orderNum")
            : "";
          this.chapterParams.chapterorder =
            this.$base.getStorage("chapterOrder");
          this.chapterParams.chapterId = this.$base.getStorage("chapterId");
          this.initSetting();
          this.getChapterContent(true);
          this.randerNum = (98 + Math.random() * (99.9 - 98)).toFixed(1);
          this.startTime = this.$base.getCurrentDateTimeSeconds(); //开始阅读时间
          this.getActivityReaderUrl();
          this.getBottomOfPageQrCodeUrl();
        }
      });
    },
    showCata() {
      this.openCata = true;
      this.isShowColor = false;
      this.isShowLine = false;
      this.toView = this.chapterParams.chapterId;
      this.openHiddenBox();
      console.log("chapterId" + this.toView);
    },
    openHiddenBox() {
      // 处理遮罩层出现后，遮罩层下的页面仍然可以滚动的问题，（遮罩层内的内容仍然可以滚动）
      this.scrollTop = document.scrollingElement.scrollTop;
      document.body.classList.add("dialog-open");
      document.body.style.top = -this.scrollTop + "px";
    },
    //这是关闭遮罩层的方法
    closeHiddenBox() {
      // 处理遮罩层出现后，遮罩层下的页面仍然可以滚动的问题，（遮罩层内的内容仍然可以滚动）
      document.body.classList.remove("dialog-open");
      document.scrollingElement.scrollTop = this.scrollTop;
    },
    getDetail() {
      var params = {
        bookId: this.bookid,
      };
      this.$api.getBookInfo(params).then((res) => {
        if (res.status == 1) {
          this.bookInfo = res.data.bookInfoDTO;
          this.shareContent = res.data.shareContent;
          this.share();
          var name =
            this.bookInfo.bookName +
            " 第" +
            this.chapterInfo.chapterOrders +
            "章";
          if (this.chapterInfo.chapterOrders) {
            document.title = name;
          }
        }
      });
    },
    share() {
      var realUrl = window.location.href;
      this.$api.getSignature({ realUrl: realUrl }).then((res) => {
        if (res.status == 1) {
          this.jweixinShare(res.data);
        }
      });
    },
    jweixinShare(data) {
      var that = this;
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: data.appId, // 必填，公众号的唯一标识
        timestamp: data.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.nonceStr, // 必填，生成签名的随机串
        signature: data.signature, // 必填，签名
        jsApiList: data.jsApiList, // 必填，需要使用的JS接口列表
      });
      var linkUrl = window.location.origin + "/" + window.location.hash;
      wx.ready(() => {
        wx.updateAppMessageShareData({
          //测试分享到朋友
          title: that.bookInfo.bookName, // 标题
          desc: that.shareContent, // 分享描述
          link: linkUrl,
          imgUrl: that.bookInfo.bookLogoUrl,
          success: () => {},
        });
      });
      wx.error(function (res) {
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
      });
    },
    getBookReadLog(flag) {
      var params = {
        bookId: this.bookid,
        chapterId: this.chapterid,
        continueRead: this.continueRead,
      };
      this.$api.getbookreadlog(params).then((res) => {
        if (res.status === 1) {
          if (this.continueRead == 1) {
            //判断是否是从继续阅读进入
            this.bookid = res.data.bookId;
            this.chapterParams.bookId = res.data.bookId;
          }
          this.chapterParams.chapterId = res.data.chaptersId;
          this.chapterParams.chapterorder = res.data.chapterPos;
        } else {
          this.chapterParams.chapterId = -1;
        }
        if (!flag) {
          this.chapterParams.order = 0;
        }
        this.initSetting();
        this.getChapterContent(flag);
      });
    },
    getChapterContent(flag) {
     if(flag&&this.fromPage=='bookCharge'){
      this.chapterParams.order=5;
     }
      var params = this.chapterParams;
      console.log(this.chapterParams);

      this.$api.findChapterContentByChapterId(params).then((res) => {
        console.log(res);
        if (res.status == 1) {
          this.showBuyMask = false;
          this.showAutoBuyMask=false;
          this.chapterParams.purchaseWholeBook = 0;
          if (res.data.bookStatus == 2) {
            Toast({
              message: "书籍不存在",
            });
            setTimeout(() => {
              this.$base.setStorage("tabbarIndex", 1);
              this.$router.replace({ path: "/" });
            }, 200);
          } else {
            if (res.data.qRCodeUrl != "") {
              this.isShowQcode = true;
              this.qcodeUrl = res.data.qRCodeUrl;
            } else {
              this.chapterInfo = res.data;
              var arr = res.data.chapterContent.split("\n");
              this.chapterContent = [];
              arr.forEach((item) => {
                if (item && item.trim()) {
                  this.chapterContent.push(item.trim());
                }
              });
              if (
                (this.chapterInfo.id != this.chapterParams.chapterId &&
                  this.chapterParams.order == 4 &&
                  this.chapterParams.rechargeOrderNum) ||
                this.chapterParams.order == 0 || this.chapterParams.order == 5 ||
                (this.chapterParams.order != 4 &&
                  this.chapterInfo.id == this.chapterParams.chapterId &&
                  this.chapterParams.rechargeOrderNum)) {
                setTimeout(() => {
                  window.scrollTo(0, this.readingOffset);
                }, 200);
              } else {
                window.scrollTo(0, 0);
              }
              if (res.data.chapterPrice > 0) {
                this.getUserCurrency();
              }
              this.syncbookreadlog();
            }
          }
        } else if (res.status == 100 || res.status == 200) {
          if (this.externalLink == 1) {
              this.$router.push({
                path: "/pages/bookCatalog/index",
                query: {
                  bookId:this.bookid,
                  pageType: "bookRead",
                }
              });
            return false;
          }
          if (res.data) {
            this.$base.setStorage("order", this.chapterParams.order);
            this.$base.setStorage(
              "chapterOrder",
              this.chapterParams.chapterorder
            );
            this.$base.setStorage("chapterId", this.chapterParams.chapterId);
            this.$router.push({
              path: "/pages/bookCharge/index",
              query: {
                bookId: this.bookid,
                chapterId: res.data.id,
                needCurrency: res.data.chapterPrice,
                pageType: "bookRead",
                priceType:res.data.priceType
              },
            });
          }
        } else if (res.status == 3) {
          //处理整本书购买的逻辑
          this.$base.setStorage("order", this.chapterParams.order);
          if (this.chapterParams.order == 2 || this.chapterParams.order == 1) {
            this.$base.setStorage(
              "chapterOrder",
              this.chapterParams.chapterorder
            );
            this.$base.setStorage("chapterId", this.chapterParams.chapterId);
          } else {
            this.$base.setStorage("chapterOrder", res.data.chapterOrders);
            this.$base.setStorage("chapterId", res.data.id);
          }
          this.countCurrency = res.data.wholeBookCurrency;
          this.userCurrency = res.data.accountCurrency;
          console.log("externalLink" + this.externalLink);
          if (this.externalLink == 1) {
            //判断是否从外部链接进入（菜单，消息等。。。）
            console.log(res.data.accountCurrency);
            console.log(res.data.wholeBookCurrency);
            if (res.data.wholeBookCurrency <= res.data.accountCurrency) {
              this.showBuyMask = true;
            } else {
                this.$router.push({
                path: "/pages/bookCatalog/index",
                query: {
                  bookId:this.bookid,
                  pageType: "bookRead",
                }
              });
              // this.$router.replace({
              //   path: "/",
              //   query: {
              //     tabIndex: 0,
              //   },
              // });
            }
            return false;
          }
          this.showBuyMask = true;
          this.chapterInfo.id = res.data.id;
          this.chapterNewId=res.data.id;
          if (res.data.qRCodeUrl != "") {
            this.isShowQcode = true;
            this.qcodeUrl = res.data.qRCodeUrl;
          }
          console.log(res.data);
          console.log(this.countCurrency);
          console.log(this.userCurrency);
        } else if(res.status==4){//订阅流程
         this.$base.setStorage("order", this.chapterParams.order);
         console.log('11111111')
         console.log(this.chapterParams.order == 2)
          if (this.chapterParams.order == 2 || this.chapterParams.order == 1) {
            this.$base.setStorage(
              "chapterOrder",
              this.chapterParams.chapterorder
            );
            this.$base.setStorage("chapterId", this.chapterParams.chapterId);
          } else {
            this.$base.setStorage("chapterOrder", res.data.chapterOrders);
            this.$base.setStorage("chapterId", res.data.id);
          }
           this.countCurrency = res.data.chapterPrice;
          this.userCurrency = res.data.accountCurrency;
          if (this.externalLink == 1) {
            //判断是否从外部链接进入（菜单，消息等。。。）
            console.log(res.data.accountCurrency);
            console.log(res.data.chapterPrice);
            if (res.data.chapterPrice <= res.data.accountCurrency) {
               this.showAutoBuyMask=true;
            } else {
                this.$router.push({
                path: "/pages/bookCatalog/index",
                query: {
                  bookId:this.bookid,
                  pageType: "bookRead",
                }
              });
            }
            return false;
          }
          this.showAutoBuyMask = true;
          this.chapterInfo.id = this.chapterParams.chapterId;
          this.chapterNewId=res.data.id;
          if (res.data.qRCodeUrl != "") {
            this.isShowQcode = true;
            this.qcodeUrl = res.data.qRCodeUrl;
          }
        }else  if(res.status==5){
          this.$router.push({
                path: "/pages/bookCatalog/index",
                query: {
                  bookId:this.bookid,
                  pageType: "bookRead",
                }
              });
        }else{
          Toast({
            message: res.message,
          });
        }
        this.$base.removeStorage("orderNum");
        this.getDetail();
      });
    },
    getUserCurrency() {
      var params = {
        random: Math.random(),
      };
      this.$api.getUserCurrency(params).then((res) => {
        if (res.status == 1) {
          this.$base.setStorage("currency", res.data);
        }
      });
    },
    syncbookreadlog() {
      let updateReadbookParams = {
        bookId: this.bookid,
        lastReadChapterId: this.chapterInfo.id,
        lastReadChapterOrder: this.chapterInfo.chapterOrders,
        lastReadTime: this.$base.getCurrentDateTimeSeconds(),
        readingOffset: this.readingOffset,
      };
      this.$api.syncbookreadlog(updateReadbookParams).then((res) => {});
    },
    changeSize(type) {
      this.isChangeRecord = true;
      if (type == "release") {
        if (this.fontSizeChange >= 26) {
          Toast({
            message: "已经是最大了",
          });
          return;
        }
        this.fontSizeChange = parseInt(this.fontSizeChange) + 1;
        this.$base.setStorage("fontSizeChange", this.fontSizeChange);
      } else if (type == "reduce") {
        if (this.fontSizeChange <= 14) {
          Toast({
            message: "已经是最小了",
          });
          return;
        }
        this.fontSizeChange = parseInt(this.fontSizeChange) - 1;
        this.$base.setStorage("fontSizeChange", this.fontSizeChange);
      }
    },
    changeColor(item) {
      this.backgroundColor = item.color;
      this.chapterClass = item.color + "-content";
      this.borderClass = this.backgroundColor + "-border";
      this.prevBgcolor = item.color;
      this.isChangeRecord = true;
      this.$base.setStorage("backgroundColor", this.backgroundColor);
      this.$base.setStorage("prevBgcolor", this.prevBgcolor);
    },
    changeLineHeight(item){
      this.isChangeRecord = true;
      this.lineHeight=item.value;
      this.$base.setStorage("lineHeight", this.lineHeight);

    },
    changeMoon() {
      if (this.backgroundColor != "night") {
        this.backgroundColor = "night";
      } else {
        this.backgroundColor = this.prevBgcolor;
      }
      this.isShowColor = false;
      this.isShowLine = false;
      this.$base.setStorage("backgroundColor", this.backgroundColor);
      this.isChangeRecord = true;
      this.chapterClass = this.backgroundColor + "-content";
      this.borderClass = this.backgroundColor + "-border";
    },
    changeSetting() {
      if (this.readingStyle == 1) {
        this.showSetting = !this.showSetting;
        if (!this.showSetting && this.isChangeRecord) {
          //上报修改阅读器设置
          this.insertReaderRecord();
        }
      } else {
        if (this.isShowColor) {
          this.isShowColor = false;
        }
        if (this.isShowLine) {
          this.isShowLine = false;
        }
      }
    },
    jumpChapter(order) {
      if (order === 1 && this.chapterInfo.chapterOrders === 1) {
        Toast({
          message: "当前已经是第一章节",
        });
        return;
      }

      if (
        order === 2 &&
        this.chapterInfo.chapterOrders === this.bookInfo.numChapters
      ) {
        this.$api.getBookJoinInfo({ bookId: this.bookid }).then((res) => {
          if (res.status == 1) {
            if (res.data) {
              this.bookIdA=this.bookid;
              this.$router.replace({
                path: "/pages/bookRead/index",
                query: {
                  bookid: res.data,
                  pageType: "bookRead",
                },
              });
            } else {
              this.$router.push({
                path: "/pages/bookRecommandread/index",
                query: {
                  bookFinish: this.bookInfo.bookFinish,
                  bookid: this.bookid,
                },
              });
            }
          } else {
            Toast({
              message: res.message,
            });
          }
        });
        return;
      }
      this.externalLink = 0;
      this.isShowColor = false;
      this.isShowLine = false;
      this.chapterParams.order = order;
      this.chapterParams.chapterId = this.chapterInfo.id;
      this.chapterParams.chapterorder = this.chapterInfo.chapterOrders;
      this.chapterParams.rechargeOrderNum = "";
      this.showSetting = false;
      if (!this.showSetting && this.isChangeRecord) {
        //上报修改阅读器设置
        this.insertReaderRecord();
      }
      this.endTime = this.$base.getCurrentDateTimeSeconds();
      this.duration = this.endTime - this.startTime;
      this.sendReadTime();
      this.getChapterContent();
    },
    goback() {
      if (this.isOutReaderStatus == "0") {
        this.getRecommendOtherBooks();
      } else {
        this.routeBack();
      }
    },
    routeBack() {
      this.isReturn = true;
      this.$router.go(-1);
      this.showSetting = false;
      if (!this.showSetting && this.isChangeRecord) {
        //上报修改阅读器设置
        this.insertReaderRecord();
      }
    },
    routeRead(item) {
      this.isOutReader = false;
      this.$router.push({
        path: "/pages/bookRead/index",
        query: {
          bookid: item.id,
          pageType: "bookRead",
        },
      });
    },
    emitEvt(data) {
      if (data.data) {
        this.externalLink = 0;
        this.chapterParams.order = 4;
        this.chapterParams.chapterId = data.data.id;
        this.chapterParams.chapterorder = data.data.chapterOrders;
        this.chapterParams.rechargeOrderNum = "";
        // window.scrollTo(0,0)
        this.getChapterContent();
        this.showSetting = false;
        this.endTime = this.$base.getCurrentDateTimeSeconds();
        this.duration = this.endTime - this.startTime;
        this.sendReadTime();
      }
      if (!this.showSetting && this.isChangeRecord) {
        //上报修改阅读器设置
        this.insertReaderRecord();
      }
      this.openCata = false;
      this.closeHiddenBox();
    },
    sendReadTime() {
      var params = {
        duration: this.duration,
      };
      this.$api.sendReadTime(params).then((res) => {
        if (res.status == 1) {
          this.startTime = this.$base.getCurrentDateTimeSeconds();
        }
      });
    },
    getRecommendOtherBooks() {
      var params = {
        bookId: this.bookid,
      };
      this.$api.getRecommendOtherBooks(params).then((res) => {
        if (res.status == 1) {
          res.data.forEach((item) => {
            var num = (item.studyingVolume / 10000).toFixed(2);
            if (num >= 999.99) {
              item.studyingVolume = 999.99;
            } else {
              item.studyingVolume = num;
            }
          });
          this.recommendList = res.data;
          if (this.recommendList.length == 0) {
            this.isOutReader = false;
            this.routeBack();
            // this.isRecommond=1;
            // next();
          } else {
            this.isRecommond = -1;
            this.isOutReader = true;
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.collect-mask {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.8);
}
.collect-mask img:nth-child(1) {
  position: absolute;
  right: 50px;
  top: 16px;
  width: 183px;
  height: 52px;
  z-index: 2;
}
.collect-mask img:nth-child(2) {
  position: absolute;
  left: 30px;
  bottom: 144px;
  width: 207px;
  z-index: 3;
}
.collect-mask img:nth-child(3) {
  position: absolute;
  bottom: 0px;
  left: 0px;
  width: 100%;
  z-index: 2;
}

.qCode_bottom {
  text-align: center;
  padding-bottom: 30px;
  margin-top: 10px;
}
.qCode_bottom p {
  font-size: 12px;
}
.qCode_bottom > p {
  color: #333333;
}
.qCode_bottom .qCode_Text {
  color: rgba(255, 255, 255, 0.7);
}
.qCode_bottom p:nth-of-type(2) {
  color: #888888;
}
.qCode_bottom img {
  width: 108px;
  height: 108px;
  margin: 12px auto;
}
.collect {
  font-size: 12px;
  color: #2d9ef2;
  text-align: center;
  margin: 20px 0px;
}
.content_title {
  display: flex;
  justify-content: space-between;
  padding: 20px 16px;
}
.content_title > div {
  display: flex;
}
.content_title > div > img {
  width: 13px;
  height: 13px;
  margin-top: 4.5px;
}

.content_title > div > span {
  margin-left: 8px;
  white-space: nowrap;
  overflow: hidden;
  display: block;
  text-overflow: ellipsis;
  width: 200px;
  font-weight: bold;
  font-size: 16px;
}

.content_title > span {
  font-size: 15px;
}

.read_set {
  display: flex;
  padding: 16px;
  justify-content: space-between;
}

.read_set > div {
  display: flex;
}

.read_set > div > img {
  margin-right: 12px;
  width: 24px;
  height: 24px;
}
.read_set > div>div>img{
  display: block;
  width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 6px;
  background: rgba(0, 0, 0, 0.05);
  margin-right: 12px;
}
.read_set span {
  display: block;
  width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 6px;
  text-align: center;
  background: rgba(0, 0, 0, 0.05);
  font-size: 14px;
  margin-right: 12px;
}

.yellow_reduce {
  border: 1px solid #d9c7ad;
  color: rgba(0, 0, 0, 0.8);
}

.blue_reduce {
  border: 1px solid #b9c3cd;
  color: rgba(0, 0, 0, 0.8);
}

.green_reduce {
  border: 1px solid #99ac98;
  color: rgba(0, 0, 0, 0.8);
}

.gray_reduce {
  border: 1px solid #c4c2bf;
  color: rgba(0, 0, 0, 0.8);
  display: inline-block;
}

.read_set span.night_reduce,.read_set img.night_reduce {
  border: 1px solid #48464e;
  background-color: #48464e;
  color: rgba(255, 255, 255, 0.7);
}

.tl-show {
  overflow: hidden;
  position: fixed;
  height: 100%;
  width: 100%;
}

page {
  height: 100%;
}

.content {
  min-height: 100%;
  box-sizing: border-box;
}

.yellow-content {
  background-color: #f1e4c8;
  color: rgba(0, 0, 0, 0.8);
}

.yellow-border {
  border-bottom: 1px solid #d9c7ad;
}

.night-content {
  background-color: #303030;
  color: rgba(219, 219, 219, 0.7);
}

.night-border {
  border-bottom: 1px solid rgba(24, 23, 26, 0.7);
}

.green-content {
  background-color: #d3e2cd;
  color: rgba(0, 0, 0, 0.7);
}

.green-border {
  border-bottom: 1px solid #99ac98;
}

.day-content {
  background-color: #fff4ee;
  color: rgba(0, 0, 0, 0.7);
}

.blue-content {
  background-color: #e3e7eb;
  color: rgba(0, 0, 0, 0.7);
}
.blue-border {
  border-bottom: 1px solid #b9c3cd;
}
.gray-content {
  background-color: #ecedec;
  /* background-image: url(../../../static/bg1.png); */
  color: rgba(0, 0, 0, 0.8);
}

.gray-border {
  border-bottom: 1px solid #c4c2bf;
}

.content-box {
  padding: 16px;
}

.content-box > span {
  display: block;
}

.chapter-title {
  font-size: 15px;
  /* font-weight: bold; */
  margin-bottom: 20px;
}

.chapter-content {
  text-indent: 2em;
  margin-bottom: 8px;
  display: block;
  text-align: justify;
  text-justify: newspaper;
  word-break: break-all;
  /* text-align: justify; */
}
/* .chapter-content:after{  
      content: '';
      display: inline-block;
      width: 100%;
    } */

.common-cata-btn > span {
  border-radius: 100px;
  font-size: 16px;
  text-align: center;
  display: block;
  padding: 9px 0px;
  width: 100%;
  background: rgba(0, 0, 0, 0.05);
}

.cata-btn > span {
  background-color: #de3b34;
  border-radius: 100px;
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  display: block;
  padding: 9px 0px;
  width: 100%;
}

.common-cata-btn > div > span {
  border-radius: 100px;
  font-size: 16px;
  text-align: center;
  display: block;
  padding: 9px 0px;
  width: 48%;
}

.yellow-cata-btn > span {
  border: 1px solid #d9c7ad;
  color: rgba(0, 0, 0, 0.8);
}

.blue-cata-btn > span {
  border: 1px solid #b9c3cd;
  color: rgba(0, 0, 0, 0.8);
}

.green-cata-btn > span {
  border: 1px solid #99ac98;
  color: rgba(0, 0, 0, 0.8);
}

.gray-cata-btn > span {
  border: 1px solid #c4c2bf;
  color: rgba(0, 0, 0, 0.8);
}

.night-cata-btn > span {
  border: 1px solid #48464e;
  background-color: #48464e;
  color: rgba(255, 255, 255, 0.7);
}

.yellow-cata-btn > div > span {
  border: 1px solid #d9c7ad;
  color: rgba(0, 0, 0, 0.8);
}

.blue-cata-btn > div > span {
  border: 1px solid #b9c3cd;
  color: rgba(0, 0, 0, 0.8);
}

.green-cata-btn > div > span {
  border: 1px solid #99ac98;
  color: rgba(0, 0, 0, 0.8);
}

.gray-cata-btn > div > span {
  border: 1px solid #c4c2bf;
  color: rgba(0, 0, 0, 0.8);
}

.night-cata-btn > div > span {
  border: 1px solid #48464e;
  color: rgba(255, 255, 255, 0.7);
}

.cata-btn-bottom {
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
}

.cata-btn-bottom > span {
  border: 1px solid #de3b34;
  border-radius: 100px;
  font-size: 16px;
  color: #de3b34;
  text-align: center;
  display: block;
  padding: 9px 0px;
  width: 48%;
}

.read-top {
  position: fixed;
  top: 0rpx;
  left: 0px;
  width: 100%;
  height: 50px;
  background-color: #1e1e1e;
  display: flex;
  justify-content: space-between;
}

.read-top > img {
  width: 50px;
  height: 50px;
}

.read-top > div {
  display: flex;
  margin-top: 16px;
}

.read-top > div > div {
  display: flex;
  margin-right: 16px;
}

.read-topdivdiv:last-of-type {
  margin-left: 14px;
}

.read-topdiv img {
  width: 22px;
  height: 22px;
}

.read-topdiv span {
  color: #d9d9d9;
  font-size: 14px;
}

.setting {
  position: fixed;
  left: 0px;
  bottom: 0px;
  background-color: #1e1e1e;
  padding: 14px 16px;
  width: 100%;
  box-sizing: border-box;
}

.setting-bottom {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.setting-bottom > div > span {
  font-size: 12px;
  color: #d9d9d9;
  display: block;
}

.setting-bottom > span {
  font-size: 14px;
  color: #d9d9d9;
  width: 227px;
  white-space: nowrap;
  overflow: hidden;
  display: block;
  text-overflow: ellipsis;
  text-align: center;
}

.setting-bottom img {
  width: 5px;
  height: 10px;
  margin: 0 auto;
  display: block;
  margin-bottom: 8px;
}

.setting-color {
  display: flex;
  margin-top: 24px;
}

.setting-color > span:nth-child(1) {
  width: 29px;
  font-size: 14px;
  color: #d9d9d9;
  line-height: 32px;
  margin-right: 61px;
}

.setting-color > div > span {
  margin-right: 26px;
  display: block;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-size: contain;
  border: 2px solid #000000;
}

.setting-topcolor,.setting-linehegiht{
  position: absolute;
  background-size: cover;
  left: -60px;
  position: absolute;
  width: 170px;
  height: 51px;
  background-image: url(../../../static/Combined.png);
  display: flex;
}
.setting-linehegiht{
  left: -75px;
}
.setting-topcolor > div,.setting-linehegiht>div{
  margin-top: 18px;
}

.setting-topcolor > div:nth-child(1) ,
.setting-linehegiht > div:nth-child(1){
  margin-left: 10px;
}
.setting-linehegiht>div>img{
  width:24px;height:24px;margin-left:12px;

}
.setting-topcolor > div > span {
  margin-right: 8px;
  display: block;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-size: contain;
  border: 2px solid #000000;
  border-color: rgba(0, 0, 0, 0);
}
.setting-topcolor > .bg-color > span {
  border-color: #ffffff;
}

.setting-topcolor > div > img {
  margin-right: 61px;
  display: block;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-size: contain;
  border: 2px solid #000000;
}

.setting-color > div > img {
  margin-right: 61px;
  display: block;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-size: contain;
  border: 2px solid #000000;
}

.setting-color > div > span.active,
.setting-topcolor > div > span.active {
  border: 2px solid #de3b34;
}

.setting-color > div > img.active,
.setting-topcolor > div > img.active {
  border: 2px solid #de3b34;
}

.setting-btn {
  display: flex;
  margin-top: 23px;
  border-top: 1px solid #555555;
  justify-content: space-between;
  padding-top: 20px;
}

.setting-btndiv {
  flex: 1;
  text-align: center;
  padding-top: 14px;
}

.setting-btn img {
  width: 18px;
  display: block;
  height: 14px;
  margin: 0 auto;
  margin-bottom: 8px;
}

.setting-btn span {
  font-size: 12px;
  color: #d9d9d9;
}

.recommand-mask {
  position: fixed;
  top: 0px;
  left: 0px;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
}

.recommand-mask > div {
  width: 100%;
  padding: 16px;
  background-color: #ffffff;
  position: absolute;
  bottom: 0px;
  left: 0px;
  box-sizing: border-box;
  padding-bottom: 50px;
  border-radius: 15px 15px 0 0;
  height: 85%;
}

.recommand-mask > div > span {
  font-size: 18px;
  color: #333333;
  font-weight: bold;
}

.recommand-content {
  height: 95%;
  overflow-y: scroll;
}

.recommand-btn {
  display: flex;
  justify-content: space-between;
  position: fixed;
  left: 0px;
  bottom: 0px;
  width: 100%;
  border-top: 1px solid #f3f3f3;
}

.recommand-btn > span {
  flex: 1;
  display: block;
  text-align: center;
  height: 44px;
  font-size: 16px;
  color: #aaaaaa;
  line-height: 44px;
  background-color: #ffffff;
}

.recommand-btn > span:nth-child(2) {
  background-color: #de3b34;
  color: #ffffff;
}

.activity-mask {
  position: fixed;
  right: 8px;
  bottom: 161px;
  flex-direction: column;
  align-items: center;
  width: 80px;
  height: 105px;
}

.activity-mask > .delete-activity {
  position: absolute;
  right: 0px;
  top: 0px;
  width: 24px;
  height: 24px;
}

.activity-mask > .icon-img {
  width: 80px;
  height: 80px;
  margin-top: 25px;
  animation-name: Go;
  animation-duration: 1200ms;
  animation-iteration-count: 10000;
}

@keyframes Go {
  0% {
    transform: scale(1);
  }

  12.5% {
    transform: scale(0.8);
  }

  25% {
    transform: scale(1);
  }

  37.5% {
    transform: scale(0.8);
  }

  50% {
    transform: scale(1);
  }

  100% {
    transform: scale(1);
  }
}

.arrow-img {
  width: 30px;
  height: 91px;
  position: fixed;
  left: 0px;
  top: 0px;
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/view/bookRead/index.vue